import React from 'react'
import { Canvas } from '@react-three/fiber'
import AnimatedMesh from '../../Homescreen/components/AnimatedMesh'

function ObjectBtn () {
  return (
    <div className="objectBtn">
      <Canvas>
        <ambientLight />
        <pointLight position={[10, 10, 10]} />
        <AnimatedMesh />
      </Canvas>
    </div>
  )
}

export default ObjectBtn
